/**
 * One SSI summary table behind a button, opened in a dialog.
 *
 * Adult ADHD's Review & Synthesis does this rather than leaving the tables
 * expanded on the page, and the CYP Review & Synthesis copies it. The MDT
 * Review uses the same dialog so a clinician moving from the interview to
 * the MDT sees the same button, the same title and the same table.
 */

import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { SearchIcon, XIcon } from '@heroicons/react/solid';

export default function CypAdhdDecisionSummaryDialog({ label, title, description, children }) {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button
          type="button"
          className="px-4 py-2 bg-violet-900 hover:bg-violet-800 text-white text-sm font-semibold rounded-md transition-colors flex items-center gap-1"
        >
          <SearchIcon className="h-4 w-4" aria-hidden="true" />
          {label}
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="radix-dialog-overlay-motion fixed inset-0 bg-black/50 backdrop-blur-sm z-[1000]" />
        <Dialog.Content className="radix-dialog-content-centered-motion fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[90vw] max-w-5xl max-h-[80vh] overflow-y-auto bg-white rounded-lg shadow-lg p-6 focus:outline-none z-[1001]">
          <div className="flex justify-between items-center mb-4">
            <Dialog.Title className="text-xl font-semibold">{title}</Dialog.Title>
            <Dialog.Close asChild>
              <button type="button" className="rounded-full p-1 hover:bg-gray-200 focus:outline-none" aria-label="Close">
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </Dialog.Close>
          </div>
          <Dialog.Description className="sr-only">{description}</Dialog.Description>
          {children}
          <div className="mt-4 flex justify-end">
            <Dialog.Close asChild>
              <button type="button" className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 transition-colors font-semibold">
                Close
              </button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
